import { useState, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Dropdown.css";

const DropdownComponent = ({ options = [], value, onChange, name, placeholder = "Sélectionner..." }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Find the selected option's label based on its value
  const selectedOptionLabel = options.find(option => (option.value || option) === value)?.label || value;

  const handleSelect = (option) => {
    onChange({ 
      target: { 
        name: name,
        value: option
      } 
    });
    setIsOpen(false);
  };

  return (
    <div className="dropdown custom-dropdown-list" ref={dropdownRef}>
      <button
        className={`dropdown-toggle custom-dropdown-list-btn ${isOpen ? "open" : ""} ${!value ? "placeholder-text" : ""}`}
        type="button"
        onClick={() => setIsOpen(!isOpen)}
      >
        {value ? selectedOptionLabel : placeholder}
      </button>
      {isOpen && (
        <ul className="dropdown-menu show custom-dropdown-list-menu">
          {/* <li>
            <button
              className="dropdown-item custom-dropdown-list-item placeholder-text"
              onClick={() => handleSelect("")}
            >
              {placeholder}
            </button>
          </li> */}
          {options.map((option, index) => (
            <li key={index}>
              <button
                className="dropdown-item custom-dropdown-list-item"
                onClick={() => handleSelect(option.value || option)}
              >
                {option.label || option}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default DropdownComponent;
